<vn-menu-item [item]="item" [section]="MenuSection.Footer" linkClass="footer-nav-link" imageClass="footer-nav-link-img" [lazyLoadImage]="true" />
